import { Button } from "lumir-back-office-ui";
import { TextDisplay } from "lumir-back-office-ui/RmsTextDisplay";

const RecruitInfoSidebarM = ({
  careerLevel,
  positionType,
  deadline,
  location,
  salary,
}) => {
  return (
    <div className="border border-semantic-secondary-foreground-strong-default rounded-md p-[24px]">
      <div className="flex gap-12 items-center">
        <TextDisplay
          className="w-[75px]"
          size="lg"
          textData={{
            caption: "경력사항",
          }}
        />
        <TextDisplay
          size="md"
          textData={{
            description: careerLevel,
          }}
        />
      </div>
      <div className="flex-1 bg-semantic-secondary-stroke-normal-default h-[1px] my-[16px]" />
      <div className="flex gap-12 items-center">
        <TextDisplay
          className="w-[75px]"
          size="lg"
          textData={{
            caption: "채용 유형",
          }}
        />
        <TextDisplay
          size="md"
          textData={{
            description: positionType,
          }}
        />
      </div>
      <div className="flex-1 bg-semantic-secondary-stroke-normal-default h-[1px] my-[16px]" />
      <div className="flex gap-12 items-center">
        <TextDisplay
          className="w-[75px]"
          size="lg"
          textData={{
            caption: "마감일",
          }}
        />
        <TextDisplay
          size="md"
          textData={{
            description: deadline,
          }}
        />
      </div>
      <div className="flex-1 bg-semantic-secondary-stroke-normal-default h-[1px] my-[16px]" />
      <div className="flex gap-12 items-center">
        <TextDisplay
          className="w-[75px]"
          size="lg"
          textData={{
            caption: "근무지",
          }}
        />
        <TextDisplay
          size="md"
          textData={{
            description: location,
          }}
        />
      </div>
      <div className="flex-1 bg-semantic-secondary-stroke-normal-default h-[1px] my-[16px]" />
      <div className="flex gap-12 items-center">
        <TextDisplay
          className="w-[75px]"
          size="lg"
          textData={{
            caption: "예상연봉",
          }}
        />
        <TextDisplay
          size="md"
          textData={{
            description: salary,
          }}
        />
      </div>
    </div>
  );
};

export { RecruitInfoSidebarM };
